import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=f8a487a4&scoped=true&"
import script from "./EditOrganization.vue?vue&type=script&lang=js&"
export * from "./EditOrganization.vue?vue&type=script&lang=js&"
import style0 from "./EditOrganization.vue?vue&type=style&index=0&id=f8a487a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a487a4",
  null
  
)

export default component.exports